import { MyScheduleCardProps } from "@whoosh/design-system/src/apps/PatronApp/components/MyScheduleCard/MyScheduleCard";

export type MyScheduleDepartmentType = MyScheduleCardProps["departmentType"];

export const KNOWN_DEPARTMENT_TYPES: Record<MyScheduleDepartmentType, true> = {
  AQUATICS: true,
  BASKETBALL: true,
  BOATING: true,
  BUSINESS: true,
  CARD_ROOM: true,
  CLUB: true,
  CROQUET: true,
  DINING: true,
  FITNESS: true,
  GOLF: true,
  RACQUET: true,
  SALON: true,
  SPA: true,
  AXE_THROWING: true,
  BOCCE_BALL: true,
  HOCKEY: true,
  SHUFFLEBOARD: true,
};

export const getFallbackDepartmentByFacilityType = (
  facilityType: string | null | undefined
): { departmentType: MyScheduleDepartmentType; departmentName: string } => {
  switch (facilityType) {
    case "RACQUET":
      return {
        departmentType: "RACQUET",
        departmentName: "Racquet",
      };
    case "DINING":
      return {
        departmentType: "DINING",
        departmentName: "Dining",
      };
    case "SIMULATOR":
      return {
        departmentType: "GOLF",
        departmentName: "Simulator",
      };
    case "GOLF_COURSE":
    default:
      return {
        departmentType: "GOLF",
        departmentName: "Golf",
      };
  }
};

export const isKnownDepartmentType = (
  departmentType: string | null | undefined
): departmentType is MyScheduleDepartmentType => {
  if (!departmentType) {
    return false;
  }

  return Object.prototype.hasOwnProperty.call(
    KNOWN_DEPARTMENT_TYPES,
    departmentType
  );
};
